import React from "react";
import logo from '../../assets/images/banner/fabricated_banner.png'
const index = ()=>{
    return (
        <div>
            <div className="fab-banner">
                <h1 className="banner-title-fab">Prefabricated Cold Chain Solution</h1>
            </div>
        </div>
    )
}

export default index;